module.exports = __webpack_public_path__ + "static/t-nav-6-1b6e0b8c1354912a59517c0f2c2cafe9.png";